import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  option: {
    '&.focused': {
      backgroundColor: theme.palette.common.gray100,
    },
    '&.inactive': {
      cursor: 'not-allowed',
      opacity: 0.7,
      pointerEvents: 'none',
    },
    '&.selected': {
      backgroundColor: theme.palette.common.blue100,
      color: theme.palette.common.blue600,
    },
    borderRadius: 3,
    cursor: 'pointer',
    padding: theme.spacing(1.5, 2),
  },
  optionLabel: {
    color: theme.palette.text.secondary,
  },
  optionMessage: {
    fontStyle: 'italic',
    marginTop: theme.spacing(0.25),
  },
}));
